<template>
	<div class="table-taxonomies">

		<Subtitle
			:title="taxonomyType"
			/>

		<div class="has-taxos" v-if="taxonomies && taxonomies.length > 0">
			<div class="the-table">
				<div class="headers">
					<div class="row">
						<span>Name</span>
						<span>Category</span>
						<span>Used count</span>
						<span>Options</span>
					</div>
				</div>
				<div class="table">
					<div 
						class="row"
						v-for="(taxonomy, index) in taxonomies"
						:key="index"
						>
						<span>
							{{ taxonomy.name }}
						</span>
						<span>
							{{ taxonomy.category }}
						</span>
						<span>
							-
						</span>
						<span>
							<i 
								class="fal fa-pencil"
								@click="editTaxonomy(taxonomy.id)"
								/>
							<i 
								class="fal fa-trash-alt"
								v-if="$page.props.user.user_type == 'admin'"
								@click="openDeleteModal(taxonomy.id)"
								/>
						</span>
					</div>
				</div>
			</div>

			<Button 
				label="Add new"
				color="green"
				size="regular"
				icon="plus"
				@click="addNewTaxonomy"
				/>

		</div>

		<div class="empty-results" v-else>
			<Placeholder 
				:message="`No ${taxonomyType} found`"
				>

				<Button 
					label="Add new"
					color="green"
					size="regular"
					icon="plus"
					@click="addNewTaxonomy"
					/>

			</Placeholder>
		</div>

		<Modal 
			v-if="deleteModalOpen && taxoIdToDelete"
			title="Delete Taxonomy"
			@close="closeDeleteModal"
			>

			<span>
				Are you sure you wish to delete this taxonomy? You CANNOT undo this!
			</span>

			<div class="buttons">
				<Button 
					label="Yes, delete"
					color="red"
					size="regular"
					icon="trash-alt"
					@click="deleteTaxonomy"
					/>

				<Button
					label="Cancel"
					color="white"
					size="regular"
					icon="times"
					@click="closeDeleteModal"
					/>
			</div>
		</Modal>

	</div>
</template>

<script>

import Placeholder from "@/Components/Placeholder"
import Button from "@/Components/Button"
import Subtitle from "@/Components/Subtitle"
import Modal from "@/Components/Modal"

export default {
	components: {
		Placeholder,
		Button,
		Subtitle,
		Modal
	},
	props: {
		taxonomies: [Array, Object],
		taxonomyType: String
	},
	data: () => {
		return {
			deleteModalOpen: false,
			taxoIdToDelete: null	
		}
	},
	methods: {
		openDeleteModal(id){
			this.deleteModalOpen = true
			this.taxoIdToDelete = id
		},
		closeDeleteModal(){
			this.deleteModalOpen = false
			this.taxoIdToDelete = null
		},
		deleteTaxonomy(){

			this.$inertia.post(`/admin/pms-forms/taxonomies/${this.taxoIdToDelete}/delete`, {
				type: this.rawType
			},
			{
				onFinish: () => {
					this.closeDeleteModal()
					this.$emit('deletedTaxonomy', this.taxoIdToDelete)
				}
			})
			
		},
		addNewTaxonomy(){
			this.$emit('addNewTaxonomy')
		},
		editTaxonomy(id){
			this.$emit('editTaxonomy', id)
		}
	},
	computed: {
		rawType(){
			if(this.taxonomyType == 'Anatomies'){
				return 'anatomy'
			}else if(this.taxonomyType == 'Case Features'){
				return 'case-feature'
			}else{
				return false
			}
		}
	},
}
</script>

<style lang="sass" scoped>

.table-taxonomies
	width: 100%
	display: flex
	flex-direction: column
	margin-bottom: 30px

	.has-taxos
		display: flex
		flex-direction: column
		gap: 20px
		margin-bottom: 20px

	.the-table
		.headers
			font-size: 18px
			font-weight: 700
			font-family: 'Roboto Condensed', sans-serif
			color: #252525
			line-height: 1.1
			margin-bottom: 10px

			.row
				padding: 0 20px

		.row
			display: grid
			grid-template-columns: 1fr 0.5fr 0.3fr 80px
			span
				display: flex
				align-items: center

				&:last-child
					justify-content: flex-end

		@media (max-width: 900px)
			overflow-x: auto
			
			.row
				display: flex

				span
					min-width: 190px

		.table
			width: 100%
			background-color: #fff
			border-radius: 8px
			box-shadow: 0 1px 3px rgba(#000, 0.12)
			padding: 0 20px

			.row
				font-size: 16px
				font-weight: 400
				font-family: 'Roboto', sans-serif
				color: #252525
				line-height: 1.1
				height: 60px
				border-bottom: 1px solid #d0d0d0
				align-items: center

				&.deleting
					color: darken(#f00, 10%)

				&:last-child
					border-bottom: none

				.fal
					font-size: 22px
					color: #252525
					margin-left: 20px
					transition: all 300ms
					cursor: pointer

					&:hover
						opacity: 0.7

	.buttons
		margin-top: 20px
		display: flex
		gap: 10px

</style>
